import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'
import {
  createStyles,
  STYLE_SIZE_CONSTANTS,
  StylesClasses,
} from '@utils/styles'

export const audioTrackZ = {
  visualizerTrack: 5,
  visualizerTracker: 10,
  trackBar: 20,
}

const styles = createStyles({
  wrapper: {},

  timer: {
    color: 'text.primary',
    minWidth: 42,
    maxWidth: 42,
  },

  trackWrapper: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '1fr',
    gridTemplateRows: '1fr',
  },

  visualizer: {
    width: '100%',
    overflow: 'hidden',
    position: 'relative',
    gridColumn: 1 / 1,
    gridRow: 1 / 1,
    placeSelf: 'center',
  },

  visualizerBg: {
    position: 'absolute',
    display: 'flex',
    overflow: 'hidden',
    alignItems: 'center',
    top: 0,
  },

  trackBar: {
    width: '100%',
    gridColumn: 1 / 1,
    gridRow: 1 / 1,
    placeSelf: 'center',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    zIndex: audioTrackZ.trackBar,
  },

  trackLine: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    cursor: 'pointer',
  },

  trackKnob: {
    width: '10px',
    height: '10px',
    borderRadius: '50%',
    backgroundColor: 'text.secondary',
    position: 'absolute',
    marginLeft: '-5px',
    cursor: 'pointer',
    zIndex: 5,
  },

  controlWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: 0.5,
  },

  hideOnSmallScreen: {
    display: {
      xs: 'none',
      md: 'inline-flex',
    },
  },
})

export type StylesClassNames = StylesClasses<typeof styles>

export default styles

interface WrapperProps {
  minified: boolean
}

export const Wrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'minified',
})<WrapperProps>(({ minified, theme }) => ({
  width: '100%',
  position: 'sticky',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-evenly',
  gap: '16px',
  borderRadius: minified ? '4px' : '16px',
  height: 'max-content',
  padding: minified ? '0px 10px' : '11px 20px',
  backgroundColor: theme.palette.background[minified ? 'default' : 'paper'],
  border: '1px solid',
  borderColor: theme.palette.border.main,
  top: STYLE_SIZE_CONSTANTS.headerHeight,

  [theme.breakpoints.down('md')]: {
    padding: minified ? '0px 8px' : '8px 10px',
    gap: '8px',
  },
}))
